import FlatButton from 'material-ui/FlatButton';
import moment from 'moment';
import React, {Component} from 'react';
import { Modal, Table } from 'react-bootstrap';
import swal from 'sweetalert';
import Button from '../../components/Button';
import InputForm from '../../components/InputForm';
import InputMaskForm from '../../components/InputMaskForm';
import LabelForm from '../../components/LabelForm';
import SelectForm from '../../components/SelectForm';
import { hl7ImssSearchPersonIdee, hl7ImssSearchPersonNss } from '../../libs/services';


class ModalSearchImss extends Component{
    constructor(props){
        super(props);

        this.handleClose = this.handleClose.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleShow = this.handleShow.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onCheck = this.onCheck.bind(this);
        this.onSelect = this.onSelect.bind(this);

        this.state = {
            show: false,
            search_type:"",
            nss:"",
            medical_attache:"",
            idee:"",
            list:[],
            search:""
        }
    }

    componentDidMount(){
        this.props.onRef(this);
    }

    handleShow(search = 'donor'){
        this.setState({show:true, search: search});
    }

    handleChange(e){        

        if(e.target.name === 'search_type'){
            this.setState({
                nss:"",
                medical_attache:"",
                idee:""
            });
        }

        if(e.target.name === 'idee'){
            if(e.target.value.length < 51){
                this.setState({[e.target.name]: e.target.value});
            }
        }else{
            this.setState({[e.target.name]: e.target.value});
        }
    }

    handleClose(){
        this.setState({
            show:false,
            search_type:"",
            nss:"",
            medical_attache:"",
            idee:"",
            list:[]
        });
    }

    async onSearch(e, params){
        var {complete} = params;
        e.preventDefault();
        var valid = true;
        var response;

        if(document.getElementById('search_type') !== null){
			if(this.state.search_type === ""){
				document.getElementById('search_type').classList.add('error');
			}else{
				document.getElementById('search_type').classList.remove('error');
			}
		}

        if(this.state.search_type === 'NSS'){
            if(this.state.nss === ""){
                valid = false;
                if(document.getElementById('nss') !== null){
                    document.getElementById('nss').classList.add('error');
                }
            }else{
                if(document.getElementById('nss') !== null){
                    document.getElementById('nss').classList.remove('error');
                }
            }
        }else if(this.state.search_type === 'IDEE'){
            if(this.state.idee === ""){
                valid = false;
                if(document.getElementById('idee') !== null){
                    document.getElementById('idee').classList.add('error');
                }
                
            }else{
                if(document.getElementById('idee') !== null){
                    document.getElementById('idee').classList.remove('error');
                }
            }
        }

        this.setState({list:[]});

        if(valid){
            if(this.state.search_type === 'NSS'){
                response = await hl7ImssSearchPersonNss(
                            this.state.nss,
                            this.state.medical_attache,
                            sessionStorage.getItem('health_facilities_id'),
                            complete,
                            this.props.waiting
                        );
               
            }else if(this.state.search_type === 'IDEE'){
                response = await hl7ImssSearchPersonIdee(this.state.idee, sessionStorage.getItem('health_facilities_id'), true, this.props.waiting);
                
            }

            if(response !== undefined && response !== null){
                response.map((res)=>{
                    res.check = false;
                });
                this.setState({list:response});
            }
        }else{
			swal('Error', 'Campos incompletos', 'error');
		}
    }

    onCheck(e, i){
        var list = this.state.list;

        list.forEach((item, j)=>{
            item.check = false;

            if(i === j){
                item.check = true;
            }
        });

        this.setState({list: list});
    }

    onSelect(){
        var list = this.state.list;
        var selected = [];

        list.forEach((item)=>{
            if(item.check){
                if(this.state.search !== 'donor'){
                    item.id = item.patient_id;
                }

                selected = [item];
            }
        });

        if(this.state.search_type !== ""){
            if(selected.length > 0){
                this.props.updateState(selected);
                this.handleClose();
            }else{
                swal('Error', 'Debe seleccionar un nombre', 'error');
            }
        }else{
            swal('Error', 'Debe seleccionar un tipo de busqueda', 'error');
        }
        
    }

    render(){
        return (
            <Modal bsSize="lg" show={this.state.show} onHide={this.handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Búsqueda</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='form-group row'>
                        <div className='form-group col-xs-12'>
                            <div className="col-xs-12 col-sm-2">
                                <LabelForm text="Tipo" />
                                <SelectForm 
                                    id="search_type"
                                    value={this.state.search_type}
                                    handleChange={this.handleChange}
                                    options={[{value:'NSS', text:'NSS'},{value:'IDEE', text:'IDEE'}]}
                                />
                            </div>
                            {this.state.search_type === 'NSS' ?
                                <>
                                    <div className="col-xs-12 col-sm-2">
                                        <LabelForm text="NSS" styles={{marginRight:5}} />
                                        <span>(*)</span>
                                        <InputMaskForm 
                                            id="nss" 
                                            value={this.state.nss} 
                                            mask='1111111111'
                                            placeholder='' 
                                            handleChange={this.handleChange}
                                        />
                                    </div>
                                    <div className="col-xs-12 col-sm-2">
                                        <LabelForm text="Agregado Médico" />
                                        <InputMaskForm 
                                            id="medical_attache"
                                            value={this.state.medical_attache}
                                            mask="1A1111AA"
                                            placeholder=''
                                            handleChange={this.handleChange}
                                        />
                                    </div>
                                    
                                </>
                            :this.state.search_type === 'IDEE' ?
                                <>
                                    <div className="col-xs-12 col-sm-2">
                                        <LabelForm text="IDEE" styles={{marginRight:5}} />                                        
                                        <LabelForm text="(*)" />
                                        <InputForm 
                                            id="idee" 
                                            value={this.state.idee} 
                                            handleChange={this.handleChange} 
                                        />    
                                    </div>
                                </>
                            :null}
                            {this.state.search_type !== "" &&
                                <div className="col-xs-12 col-sm-2" style={{marginTop:'18px'}}>
                                    <Button 
                                        class='btn-info'
                                        styles={{width:'100&'}}
                                        title="Buscar"
                                        text="BUSCAR"
                                        action={this.onSearch}
                                        params={{complete:true}}
                                    />
                                </div>
                            }
                        </div>
                        <div className='form-group col-xs-12'>
                            <Table responsive hover>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Nombre</th>
                                        <th>IDEE</th>
                                        <th>NSS</th>
                                        <th>Agregado</th>
                                        <th>Fecha Nacimiento</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.list.map((list, i)=>
                                        <tr key={i}>
                                            <td>
                                                <input type='checkbox' checked={list.check} value={list.check} onChange={(e)=>this.onCheck(e, i)} />
                                            </td>
                                            <td>{list.NOMBRE}</td>
                                            <td>{list.IDEE}</td>
                                            <td>{list.NSS}</td>
                                            <td>{list.AGREGADO_MEDICO}</td>
                                            <td>
                                                {list.FECHA_NACIMIENTO  !== null ? 
                                                    moment(list.FECHA_NACIMIENTO.DateTime).format('DD/MM/YYYY')
                                                : ""}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <FlatButton primary={true} label="Cancelar"  onClick={this.handleClose}/>
                    <FlatButton primary={true} label="Aceptar"  onClick={this.onSelect}/>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default ModalSearchImss;